module.exports = new __parcel__URL__("github.a2abf599.svg").toString();